var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-simple-markdown',{attrs:{"source":_vm.source,"emoji":false,"highlight":false,"image":false,"inlineCode":false,"blockquote":false,"table":false,"link":false,"linkify":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }